module.exports = __webpack_public_path__ + "static/media/1-N-okas.9a34885c.webp";